import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map, catchError, startWith ,tap} from 'rxjs/operators';
import { Observable, switchMap,BehaviorSubject } from 'rxjs';
import { HttpErrorHandler, HandleError } from './common/http-error-handler.service';

import { bearerToken } from './common/auth.service';
import { urls as apis } from './apiUrls';
import { httpOptions } from './common/common.service';
import { BeachSite } from '../models/BeachSite';
import { sortBy } from 'lodash';


@Injectable()
export class SitesService {	

	private handleError: HandleError;

	constructor(private http: HttpClient, httpErrorHandler: HttpErrorHandler) {
		this.handleError = httpErrorHandler.createHandleError('SitesService');
	}

	public sites$ : BehaviorSubject<BeachSite[]> = new BehaviorSubject<BeachSite[]>([]);

	getSites(): Observable<BeachSite[]> {
		return this.sites$.asObservable();
	}

	getSitesApi(): Observable<BeachSite[]> {
		return this.http
			.get(apis.sitesUrl, httpOptions)
			.pipe(
				map((data : any) => {
					return sortBy(data?.features?.map((a : any) => {
						return new BeachSite(
							a.properties.identifier,
							a.properties.site_name,
							a.properties.pollution_forecast,
							a.properties.latest_result_star_rating,
							a.properties.council, a.properties.sub_region, a.properties.parent_region,
							a.properties.partner_group,
							a.geometry.coordinates[1], a.geometry.coordinates[0],
							a.properties.site_type);	
					}), "SiteName")
				}),
				catchError(this.handleError('getSites', []))
			);
	}
	
	populateSites(): void{
		this.http
		.get(apis.sitesUrl, httpOptions)
		.pipe(
				map((data : any) => {
					return sortBy(data?.features?.map((a : any) => {
						return new BeachSite(
							a.properties.identifier,
							a.properties.site_name,
							a.properties.pollution_forecast,
							a.properties.latest_result_star_rating,
							a.properties.council, a.properties.sub_region, a.properties.parent_region,
							a.properties.partner_group,
							a.geometry.coordinates[1], a.geometry.coordinates[0],
							a.properties.site_type);	
					}), "SiteName")
			}),				
			catchError(this.handleError('populateSites', []))
		).subscribe({
			next: (data:any )=> this.sites$.next(data)
		});
	}

	getSitePopupInfo(siteId : string) {
		return this.http
			.get(apis.sitePopupInfoUrl.replaceAll("{id}", `${siteId}`), httpOptions)
			.pipe(catchError(this.handleError('getSitePopupInfo', {})));
	}

	lookupSearchText(text : string) {
		return this.http.get(`${apis.poiSearchUrl}?p=${text}`, httpOptions)
			.pipe(catchError(this.handleError('lookupSearchText', [])));
	}

	lookupAddress(text : string) {
		return this.http.get(`${apis.addressSearchUrl}?a=${text}`, httpOptions)
		 	.pipe(catchError(this.handleError('lookupAddress', [])));		
	}

	getAddressLatLng(addressId : number) {
		return this.http.get(`${apis.addressGeometrySrvcUrl}?id=${addressId}&type=property`, httpOptions)
			.pipe(catchError(this.handleError('getAddressLatLng', null)));
	}

	getSubscribeSitesList() : Observable<BeachSite[]> {
		return this.http
			.get(apis.subscribeSitesList, httpOptions)
			.pipe(
				map((data : any) => {
					return sortBy(data?.map((a : any) => {
						return new BeachSite(
							a.SiteGuid?.toString(),
							a.SiteName?.toString(),
							"",
							-1,
							a.CouncilName, 
							a.RegionName,
							"",
							"",
							0, 
							0,
							"");	
					}), "SiteName");
				}),				
				catchError(this.handleError('getSitesList', []))
			);		
	}

	getDownloadDataSitesList() : Observable<BeachSite[]> {
		return this.http
			.get(apis.downloadDataSitesList, httpOptions)
			.pipe(
				map((data : any) => {
					return sortBy(data?.map((a : any) => {
						return new BeachSite(
							a.SiteGuid?.toString(),
							a.SiteName?.toString(),
							"",
							-1,
							a.CouncilName, 
							a.RegionName,
							"", 
							"",
							0, 
							0,
							"");	
					}), "SiteName");
				}),				
				catchError(this.handleError('getDownloadDataSitesList', []))
			);
		
	}

	getSitesList (url : string) {
		return this.http
			.get(url, httpOptions)
			.pipe(
				map((data : any) => {
					return sortBy(data?.map((a : any) => {
						return new BeachSite(
							a.SiteGuid?.toString(),
							a.SiteName?.toString(),
							"",
							-1,
							a.CouncilName, 
							a.RegionName, 
							"",
							"",
							0, 
							0,
							"");	
					}), "SiteName");
				}),				
				catchError(this.handleError('getSitesList', []))
			);
	}

	
}
